import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkUpdatePosts } from '../services/postService';
import { logger } from '../utils/logger';

interface BulkUpdateResponse {
  success: boolean;
  updated: number;
  failed: string[];
  errors: any[];
}

interface BulkUpdateParams {
  postIds: string[];
  updateData: {
    status?: string;
    brandId?: string;
    platforms?: string[];
  };
}

export const useBulkUpdatePosts = () => {
  const queryClient = useQueryClient();
  
  return useMutation<BulkUpdateResponse, Error, BulkUpdateParams>({
    mutationFn: async ({ postIds, updateData }): Promise<BulkUpdateResponse> => {
      try {
        logger.info('useBulkUpdatePosts', `Bulk updating ${postIds.length} posts`);
        const result = await bulkUpdatePosts(postIds, updateData);
        
        logger.info('useBulkUpdatePosts', `Bulk update completed: ${result.updated} updated, ${result.failed.length} failed`);
        return result;
      } catch (error) {
        logger.error('useBulkUpdatePosts', 'Error in bulk update:', error);
        throw error;
      }
    },
    onSuccess: (data) => {
      // Invalidate the posts query to refetch the list
      queryClient.invalidateQueries({ queryKey: ['posts'] });
      logger.info('useBulkUpdatePosts', 'Posts queries invalidated');
    }
  });
}; 